export const REQUEST_CALENDER_DATA = 'REQUEST_CALENDER_DATA';
export const CALENDER_DATA_RECEIVED = 'CALENDER_DATA_RECEIVED';